import { PAGES } from "redux/actions/pages/constants";

// feature name
export const SOUND_MATERIAL_ITEMS = `${PAGES} [SoundMaterialItems]`;

// action types
export const CREATE_SOUND_MATERIAL = `${SOUND_MATERIAL_ITEMS} CREATE`;
export const GET_SOUND_GROUPS_LOOKUPS = `${SOUND_MATERIAL_ITEMS} GET_SOUND_GROUPS_LOOKUPS`;
export const GET_SOUND_LETTERS_LOOKUPS = `${SOUND_MATERIAL_ITEMS} GET_SOUND_LETTERS_LOOKUPS`;
export const GET_SOUND_MATERIAL_BY_LETTER = `${SOUND_MATERIAL_ITEMS} GET_SOUND_MATERIAL_BY_LETTER`;
export const GET_SOUND_MATERIAL_TYPE_LOOKUPS = `${SOUND_MATERIAL_ITEMS} GET_SOUND_MATERIAL_TYPE_LOOKUPS`;
export const GET_MINE_SOUND_MATERIAL = `${SOUND_MATERIAL_ITEMS} GET_MINE_SOUND_MATERIAL`;
export const DELETE_MINE_SOUND_MATERIAL = `${SOUND_MATERIAL_ITEMS} DELETE_MINE_SOUND_MATERIAL`;

// action creators
export const createSoundMaterial = (soundMaterial) => ({
  type: CREATE_SOUND_MATERIAL,
  payload: { soundMaterial },
});

export const getSoundMaterialByLetter = (letter) => ({
  type: GET_SOUND_MATERIAL_BY_LETTER,
  payload: { letter },
});

export const getMineSoundMaterial = () => ({
  type: GET_MINE_SOUND_MATERIAL,
});

export const deleteMineSoundMaterial = (soundMaterialId) => ({
  type: DELETE_MINE_SOUND_MATERIAL,
  payload: { soundMaterialId },
});

export const getSoundGroupsLookups = () => ({
  type: GET_SOUND_GROUPS_LOOKUPS,
});

export const getSoundLettersLookups = () => ({
  type: GET_SOUND_LETTERS_LOOKUPS,
});

export const getSoundMaterialTypeLookups = () => ({
  type: GET_SOUND_MATERIAL_TYPE_LOOKUPS,
});
